import React from 'react';

const TechnicalBackground = () => {
  return (
<section className="section" id="technical_background">
    <div className="container"> 
        <div className="row justify-content-center mb-4">
            <div className="col-12 col-md-10 col-lg-7 text-center">
                <h2 className="fs-2 fw-medium lh-1 text-dark my-3">Technical Background</h2>
                <p className="text-gray-700 fs-18 fs-lg mb-4 mb-md-5 lh-lg">
                I wield a diverse arsenal of programming languages – from the low-level precision of Assembly to the high-level flexibility of Python and VB.net – to craft robust software solutions for microcontrollers and embedded systems. My expertise doesn't stop at code, though. I'm equally adept at sculpting intricate PCB designs using industry-leading tools like OrCAD, EasyEDA, Altium, and DesignSpark. This allows me to seamlessly bridge the gap between software and hardware, ensuring each project receives a meticulously tailored solution.
                </p>
            </div>
        </div>
<div className="row">
<div className="col-12">
<div className="row g-0">
<div className="col-lg-4 col-md-6">
  <div className="card rounded bg-light h-100 border-0">
                            <div className="card-body d-flex justify-content-center align-items-center">
                                <div className="mx-auto text-center">
                                    <img src="assets/images/domain.png" alt="" className="vector-light" height="120"/>
                                    <h5 className="text-dark fs-22 fw-medium my-2">Sub Domains</h5>     
                                </div>                          
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-8 col-md-6">
                        <div className="card rounded bg-white  h-100 border-0">
                            <div className="card-body p-0">
                                <div className="accordion accordion-flush" id="Education_accordion">
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="second">
                                            <span className="accordion-button collapsed">
                                            Automative
                                            {/* <span className="fw-medium text-primary ms-auto fs-14">2 Years</span> */}
                                            </span>
                                        </h2>
                                    </div>
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="second">
                                            <span className="accordion-button collapsed">
                                            Health Care
                                            {/* <span className="fw-medium text-primary ms-auto fs-14">2 Years</span> */}
                                            </span>
                                        </h2>
                                    </div>
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="higher">
                                            <span className="accordion-button collapsed">
                                            Evaluation Kits
                                            {/* <span className="fw-medium text-primary ms-auto fs-14">2 Years</span> */}
                                            </span>
                                        </h2>
                                    </div>
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="higher">
                                            <span className="accordion-button collapsed">
                                            Communication
                                            {/* <span className="fw-medium text-primary ms-auto fs-14">2 Years</span> */}
                                            </span>
                                        </h2>
                                    </div>
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="higher">
                                            <span className="accordion-button collapsed">
                                            Industrial
                                            {/* <span className="fw-medium text-primary ms-auto fs-14">2 Years</span> */}
                                            </span>
                                        </h2>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>       
                </div>
                <hr className="hr-dashed"/>
                 <div className="row g-0">
                  <div className="col-lg-4 col-md-6">
                        <div className="card rounded bg-light h-100 border-0">
                            <div className="card-body d-flex justify-content-center align-items-center">
                                <div className="mx-auto text-center">
                                    <img src="assets/images/skills.png" alt="" className="vector-light" height="120"/>
                                    <h5 className="text-dark fs-22 fw-medium my-2">Skills</h5>     
                                </div>                          
                            </div>
                        </div>
                    </div>
                       <div className="col-lg-8 col-md-6">
                        <div className="card rounded bg-white  h-100 border-0">
                            <div className="card-body p-0">
                                <div className="accordion accordion-flush" id="Experience_accordion">
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="second">
                                            <span className="accordion-button collapsed">
                                            Board Design</span>
                                        </h2>
                                    </div>
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="second">
<span className="accordion-button collapsed">
                                            Circuit Design</span>
                                        </h2>
                                    </div>
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="higher">
                                            <span className="accordion-button collapsed">
                                            Firmware Coding</span>
                                        </h2>
                                    </div>
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="higher">
                                            <span className="accordion-button collapsed">
                                            Testing & Troubleshooting Boards</span>
                                        </h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
<hr className="hr-dashed"/>
                <div className="row">
                    <div className="col-12">
                         <div className="row g-0">
                            <div className="col-lg-4 col-md-6">
                                <div className="card rounded bg-light h-100 border-0">
                                    <div className="card-body d-flex justify-content-center align-items-center">
                                        <div className="mx-auto text-center">
                                            <img src="assets/images/circuit design.png" alt="" className="vector-light" height="120"/>
                                            <h5 className="text-dark fs-22 fw-medium my-2">Circuit Design</h5>     
                                        </div>                          
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-8 col-md-6">
                                <div className="card rounded bg-white  h-100 border-0">
                                    <div className="card-body p-0">
                                        <div className="accordion accordion-flush" id="Education_accordion">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="second">
                                                    <span className="accordion-button collapsed">
                                                    Digital Design
                                                    </span>
                                                </h2>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="second">
                                                    <span className="accordion-button collapsed">
                                                    Analog Design
                                                    </span>
                                                </h2>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="higher">
                                                    <span className="accordion-button collapsed">
                                                    Power Supply Design
                                                    </span>
                                                </h2>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="higher">
                                                    <span className="accordion-button collapsed">
                                                    Both Digital & Analog Design
                                                    </span>
                                                </h2>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="higher">
                                                    <span className="accordion-button collapsed">
                                                    RF Design
                                                    </span>
                                                </h2>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="higher">
                                                    <span className="accordion-button collapsed">
                                                    Board Design Of High Speed Signals
                                                    </span>
                                                </h2>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="higher">
                                                    <span className="accordion-button collapsed">
                                                    HDI
                                                    </span>
                                                </h2>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="higher">
                                                    <span className="accordion-button collapsed">
                                                    High Speed Design PCB Layout Using Blind Buried Vias (Mechanically, Space Constraints and High Speed Constraint Board) 
                                                    </span>
                                                </h2>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="higher">
                                                    <span className="accordion-button collapsed">
                                                    Multilayer Upto 18 Layers
                                                    </span>
                                                </h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>                            
                        </div>
</div>
</div>

                        <hr className="hr-dashed"/>
                        <div className="row">
                            <div className="col-12">
                                <div className="row g-0">
                                    <div className="col-lg-4 col-md-6">
                                        <div className="card rounded bg-light h-100 border-0">
                                            <div className="card-body d-flex justify-content-center align-items-center">
                                                <div className="mx-auto text-center">
                  
                                         <img src="assets/images/experienced.png" alt="" className="vector-light" height="120"/>
                                            <h5 className="text-dark fs-22 fw-medium my-2">Technologies Experienced</h5>     
                                        </div>                          
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-8 col-md-6">
                                <div className="card rounded bg-white  h-100 border-0">
                                    <div className="card-body p-0">
                                        <div className="accordion accordion-flush" id="Education_accordion">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="second">
                                                    <span className="accordion-button collapsed">
                                                   USB 2.0, USB 3.0, USB Transceiver    
                                               </span>
                                                </h2>
                                            </div>
                                            
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="second">
                                                    <span className="accordion-button collapsed">
                                                   I2C, SPI, CAN, A2D, D2A    
                                               </span>
                                                </h2>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="second">
                                                       <span className="accordion-button collapsed">
                                                   Flash, FPGA, Processors, AP SoC
                                                    </span>
                                                </h2>
                                              
                                            </div>
                                           
                                             <div className="accordion-item">
                                                <h2 className="accordion-header" id="higher">
                                                      <span className="accordion-button collapsed">
                                                   Ethernet 2 and Ethernet 3 interface
                                                    </span>
                                                </h2>
                                               
                                            </div>
                                            {/* <div className="accordion-item">
                                                <h2 className="accordion-header" id="higher">
                                                      <span className="accordion-button collapsed">
                                                  Battery, DDR2, DDR3, DIMM
                                                    </span>
                                                </h2>
                                               
                                            </div> */}
                                             <div className="accordion-item">
                                                <h2 className="accordion-header" id="higher">
                                                      <span className="accordion-button collapsed">
                                                  HDMI, FLASH, RAM 
                                                    </span>
                                                </h2>
                                               
                                            </div>
                                              <div className="accordion-item">
                                                <h2 className="accordion-header" id="higher">
                                                      <span className="accordion-button collapsed">
                                                  Bluetooth, WiFi
                                                    </span>
                                                </h2>
                                               
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>                            
                        </div>
</div>
</div>

                         <hr className="hr-dashed"/>
                         <div className="row">
                    <div className="col-12">
                        <div className="row g-0">
                            <div className="col-lg-4 col-md-6">
                                <div className="card rounded bg-light h-100 border-0">
                                    <div className="card-body d-flex justify-content-center align-items-center">
                                        <div className="mx-auto text-center">
                                         <img src="assets/images/processor.png" alt="" className="vector-light" height="120"/>
                                            <h5 className="text-dark fs-22 fw-medium my-2">Processors / Controllers</h5>     
                                        </div>                          
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-8 col-md-6">
                                <div className="card rounded bg-white  h-100 border-0">
                                    <div className="card-body p-0">
                                        <div className="accordion accordion-flush" id="Education_accordion">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="second">
                                                    <span className="accordion-button collapsed">
                                                   STM32    
                                               </span>
                                                </h2>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="second">
                                                       <span className="accordion-button collapsed">
                                                   STM8
                                                    </span>
                                                </h2>
                                              
                                            </div>
                                           
                                             <div className="accordion-item">
                                                <h2 className="accordion-header" id="higher">
                                                      <span className="accordion-button collapsed">
                                                  ATMEGA328
                                                    </span>
                                                </h2>
                                               
                                            </div>
                                            {/* <div className="accordion-item">
                                                <h2 className="accordion-header" id="higher">
                                                      <span className="accordion-button collapsed">
                                                  Battery, DDR2, DDR3, DIMM
                                                    </span>
                                                </h2>
                                               
                                            </div> */}
                                             <div className="accordion-item">
                                                <h2 className="accordion-header" id="higher">
                                                      <span className="accordion-button collapsed">
                                                  ADUC845
                                                    </span>
                                                </h2>
                                               
                                            </div>
                                             
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>                            
                        </div>
</div></div>
                        <hr className="hr-dashed"/>
                         <div className="row">
                    <div className="col-12">
                        <div className="row g-0">
                            <div className="col-lg-4 col-md-6">
                                <div className="card rounded bg-light h-100 border-0">
                                    <div className="card-body d-flex justify-content-center align-items-center">
                                        <div className="mx-auto text-center">
                                         <img src="assets/images/simulation.png" alt="" className="vector-light" height="120"/>
                                            <h5 className="text-dark fs-22 fw-medium my-2">Analysis / Simulation tools </h5>     
                                        </div>                          
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-8 col-md-6">
                                <div className="card rounded bg-white  h-100 border-0">
                                    <div className="card-body p-0">
                                        <div className="accordion accordion-flush" id="Education_accordion">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="second">
                                                    <span className="accordion-button collapsed">
                                                   Allegro PCB SI(Signal Integrity) & PI(Power Integrity)    
                                               </span>
                                                </h2>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="second">
                                                       <span className="accordion-button collapsed">
                                                   Hyperlynx
                                                    </span>
                                                </h2>
                                              
                                            </div>
                                           
                                             <div className="accordion-item">
                                                <h2 className="accordion-header" id="higher">
                                                      <span className="accordion-button collapsed">
                                                  P-Spice
                                                    </span>
                                                </h2>
                                               
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="higher">
                                                      <span className="accordion-button collapsed">
                                                 EMI Stream
                                                    </span>
                                                </h2>
                                               
                                            </div>
                                             <div className="accordion-item">
                                                <h2 className="accordion-header" id="higher">
                                                      <span className="accordion-button collapsed">
                                                  Valor
                                                    </span>
                                                </h2>
                                               
                                            </div>
                                             
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>                            
                        </div>
</div></div>
                        <hr className="hr-dashed"/>
                         {/* <div className="row">
                    <div className="col-12">
                        <div className="row g-0">
                            <div className="col-lg-4 col-md-6">
                                <div className="card rounded bg-light h-100 border-0">
                                    <div className="card-body d-flex justify-content-center align-items-center">
                                        <div className="mx-auto text-center">
                                         <img src="assets/images/designtool.png" alt="" className="vector-light" height="120"/>
                                            <h5 className="text-dark fs-22 fw-medium my-2">Design Tools </h5>     
                                        </div>                          
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-8 col-md-6">
                                <div className="card rounded bg-white  h-100 border-0">
                                    <div className="card-body p-0">
                                        <div className="accordion accordion-flush" id="Education_accordion">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="second">
                                                    <span className="accordion-button collapsed">
                                                   Allegro Design Entry CIS
                                               </span>
                                                </h2>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="second">
                                                       <span className="accordion-button collapsed">
                                                  Allegro PCB Design GXL(Manual and Auto Routing)
                                                    </span>
                                                </h2>
                                              
                                            </div>
                                           
                                             <div className="accordion-item">
                                                <h2 className="accordion-header" id="higher">
                                                      <span className="accordion-button collapsed">
                                                 Spectra Auto Routing With Do Files, PADS Layout,PADS Router,DX-Designer EXP '2005'  
                                                    </span>
                                                </h2>
                                               
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="higher">
                                                      <span className="accordion-button collapsed">
                                                 Altium Designer, Protel, KICAD, EAGAL, Design Entry HDL
                                                    </span>
                                                </h2>
                                               
                                            </div>
                                             <div className="accordion-item">
                                                <h2 className="accordion-header" id="higher">
                                                      <span className="accordion-button collapsed">
                                                  Labview7.1, DX-Designer EXP 2007, GerbTool
                                                    </span>
                                                </h2>
                                               
                                            </div>
                                             
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>                            
                        </div>
</div></div>
                          <hr className="hr-dashed"/> */}
                         <div className="row">
                    <div className="col-12">
                        <div className="row g-0">
                            <div className="col-lg-4 col-md-6">
                                <div className="card rounded bg-light h-100 border-0">
                                    <div className="card-body d-flex justify-content-center align-items-center">
                                        <div className="mx-auto text-center">
                                         <img src="assets/images/supportingtool.png" alt="" className="vector-light" height="120"/>
                                            <h5 className="text-dark fs-22 fw-medium my-2">Design & Development Tools </h5>     
                                        </div>                          
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-8 col-md-6">
                                <div className="card rounded bg-white  h-100 border-0">
                                    <div className="card-body p-0">
                                        <div className="accordion accordion-flush" id="Education_accordion">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="second">
                                                    <span className="accordion-button collapsed">
                                                   Pycharm
                                               </span>
                                                </h2>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="second">
                                                       <span className="accordion-button collapsed">
                                                 Solidworks eDrawing
                                                    </span>
                                                </h2>
                                              
                                            </div>
                                           
                                             <div className="accordion-item">
                                                <h2 className="accordion-header" id="higher">
                                                      <span className="accordion-button collapsed">
                                                Easy Eda, Altium Designer, KICAD, EAGLE
                                                    </span>
                                                </h2>
                                               
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="higher">
                                                      <span className="accordion-button collapsed">
                                                Proteus 
                                                    </span>
                                                </h2>
                                               
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="higher">
                                                      <span className="accordion-button collapsed">
                                                Cube IDE 
                                                    </span>
                                                </h2>
                                               
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="higher">
                                                      <span className="accordion-button collapsed">
                                                Arduino IDE 
                                                    </span>
                                                </h2>
                                               
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="higher">
                                                      <span className="accordion-button collapsed">
                                                 Vistual Studio 
                                                    </span>
                                                </h2>
                                               
                                            </div>
                                            
                                             
                                        </div>
                                    </div>
                                </div>
                            </div>                            
                        </div>
                     </div>
                     </div>
</div>

         </section>
          );
        };
    export default TechnicalBackground;